import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
let OnboardingApiImpl = class OnboardingApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: '',
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async getSuggestCompanyList() {
        const res = await this.get({
            url: `${workspaceApiUrlPrefix}/monitor/suggest-company?page=1&limit=3`,
        });
        return res.data;
    }
    async createSpaceInfo(params) {
        const res = await this.post({
            url: `${workspaceApiUrlPrefix}/wizard/submit`,
            data: params,
        });
        return res.data;
    }
    async getAssignCompany(params) {
        const res = await this.get({
            url: `${workspaceApiUrlPrefix}/wizard/assignee/search`,
            params,
        });
        return res.data;
    }
};
OnboardingApiImpl = __decorate([
    injectable()
], OnboardingApiImpl);
export { OnboardingApiImpl };
